//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconStatusPlaying(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5 20.37L19.5 12L5 3.63V20.37ZM7 7.09L15.5 12L7 16.91V7.09Z" fill="currentColor" /></svg>;
}
export default IconStatusPlaying;